import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import "./HeatmapMatrix.css";

export default function HeatmapMatrix({ data }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current) return;

    const cellSize = 120;
    const padding = 70;

    d3.select(svgRef.current).selectAll("*").remove();

    const size = cellSize * 3;
    const svg = d3
      .select(svgRef.current)
      .attr("width", size + padding * 2)
      .attr("height", size + padding * 2);

    const g = svg.append("g").attr("transform", `translate(100,0)`);

    // Matrix data
    const metaphors = ["Extension", "Tool", "Person"];
    const matrix = [
      [data.extension, data.extTool, data.extPerson],
      [data.extTool, data.tool, data.toolPerson],
      [data.extPerson, data.toolPerson, data.person],
    ];

    const maxValue = Math.max(...matrix.flat());
    const colorScale = d3
      .scaleLinear()
      .domain([0, maxValue])
      .range(["#f0f0f0", "#764ba2"]);

    // Draw cells
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        const value = matrix[i][j];
        const x = j * cellSize;
        const y = i * cellSize;

        g.append("rect")
          .attr("x", x)
          .attr("y", y)
          .attr("width", cellSize)
          .attr("height", cellSize)
          .attr("fill", colorScale(value))
          .attr("stroke", "#fff")
          .attr("stroke-width", 2);

        // Add value text
        g.append("text")
          .attr("x", x + cellSize / 2)
          .attr("y", y + cellSize / 2)
          .attr("text-anchor", "middle")
          .attr("dy", "0.3em")
          .attr("font-size", "32px")
          .attr("font-weight", "bold")
          .attr("fill", value > maxValue / 2 ? "#fff" : "#333")
          .text(value);
      }
    }

    // Draw row labels
    metaphors.forEach((label, i) => {
      g.append("text")
        .attr("x", -15)
        .attr("y", i * cellSize + cellSize / 2)
        .attr("text-anchor", "end")
        .attr("dy", "0.3em")
        .attr("font-weight", "bold")
        .attr("font-size", "16px")
        .text(label);
    });

    // Draw column labels
    metaphors.forEach((label, j) => {
      g.append("text")
        .attr("x", j * cellSize + cellSize / 2)
        .attr("y", -15)
        .attr("text-anchor", "middle")
        .attr("font-weight", "bold")
        .attr("font-size", "16px")
        .text(label);
    });
  }, [data]);

  return (
    <div className="heatmap-container">
      <h2>Co-occurrence Heatmap Matrix</h2>
      <p>Shows how many products are classified in each metaphor combination</p>
      <div className="heatmap-wrapper">
        <svg
          ref={svgRef}
          preserveAspectRatio="xMidYMid meet"
          className="heatmap-svg"
        ></svg>
        <div className="heatmap-legend">
          <p>
            <strong>How to read:</strong>
          </p>
          <ul>
            <li>Diagonal = products classified with only that metaphor</li>
            <li>Off-diagonal = products classified with both metaphors</li>
            <li>Darker = more products</li>
            <li>
              E.g., Tool-Person (876) is the darkest, showing the strongest
              overlap
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
